// src/data/texts.js

export const skillsText = `Tools that I use:
- Zed
  Mostly to code websites and command-line interface applications.
- Git
  Helps to manage my projects and collaborate with other programmers.
- Docker
  Easily sends a project to anyone without causing errors.

Frameworks that I use:
- Laravel, ReactJS.

Languages that I use:
- JavaScript, PHP, Lua.

Databases that I use:
- MySQL/MariaDB, MongoDB, Text files, JSON.

Architectures:
- RESTful API, OOP.
`;

export const welcomeText = `This website is designed to mimic a desktop environment where users can interact with various elements such as folders, files, and links.

Features:
- Double-click to open folders and files.
- Supports images, videos, text files, and links.
- Resize windows by dragging the bottom right corner.
- A taskbar that tracks open windows.

This project is a demonstration of a modern web-based desktop interface, combining React and Tailwind CSS to create a fluid and interactive user experience.

Regards,
Roza.
`;

export const aboutwebsiteText = `The website is made using create-react-app framework and TailwindCSS.
most of the time I spent coding on this project is the file system and Window Container handling,
so I am quite proud with this project since I made most of structure within 2 days and I still plan to further extend features on this website:

Future ideas for this website
- ContextMenu (you can create folder and txt file with this, also delete it.)
- Mobile Support (when using mobile to access this site, it will emulate android/ios feeling.)
- Add Terminal (the one in the taskbar is still place holder.)
- Localization ( still under work.)
You can contact me on Discord : shiniya_
`;

export const infoText = `I am not the type to reveal my real name,
Some people call me Roza (part of real name but modified) or Shin.

I prefer using PHP to make sites (especially with Laravel framework.
My hobbies were reading stories, writing code and contributing to people's repositories.

I love developing front end with React (I dont like NextJS somehow but plan on learning it)

Currently using Arch Linux (CachyOS) as Daily Driver and I love it!
Discord : shiniya_`;

export const markdownContent = `
  ![fc13532303cfd8f4f32c1c3ed68aa1f2 1](https://github.com/shinyPy/shinyPy/assets/71328419/22b65ad6-f969-4790-9cb4-bdb88eee88a6)
  <hr>
  <h1 align="center">Kapan kerjanya?</h1>
  <p align="left"> <img src="https://komarev.com/ghpvc/?username=shinypy&label=Profile%20views&color=0e75b6&style=flat" alt="shinypy" /> </p>




  <img src="https://discord.c99.nl/widget/theme-2/656757505426325527.png"/>






`;
